import { Box } from "@mui/material";
import React, { useEffect } from "react";
import PageTitle from "../base/PageTitle";
import Users from "../views/Users";
import { useNavigate } from "react-router-dom";
import { useSelector } from "../../store";
import checkRole, { UserRoles } from "../../helpers/checkUserRoles";

interface Props {}

const UsersPage: React.FC<Props> = (props) => {
  const navigate = useNavigate();

  const { dbUser } = useSelector((store) => store.auth);

  useEffect(() => {
    if (!!dbUser) {
      const auth = checkRole(dbUser, UserRoles.AnyAdmin);
      if (!auth) {
        navigate("/apps");
      }
    }
  }, [navigate, dbUser]);
  return (
    <Box>
      <PageTitle title="User Management" />
      <Users />
    </Box>
  );
};

export default UsersPage;
